document.addEventListener('DOMContentLoaded', () => {
  const spendInput   = document.getElementById('annual-spend');
  const freightInput = document.getElementById('annual-freight');
  const calcBtn      = document.getElementById('calculate-savings');

  const priceCell       = document.querySelector('[data-amount="price"]');
  const volumeCell      = document.querySelector('[data-amount="volume"]');
  const freightCell     = document.querySelector('[data-amount="freight"]');
  const opportunityCell = document.querySelector('[data-amount="opportunity"]');
  const totalCell       = document.getElementById('total-savings');

  const tableWrapper = document.querySelector('.table-wrapper');
  const overlay      = tableWrapper?.querySelector('.loading-overlay');

  const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  function attachCurrencyFormatter(input) {
    input.addEventListener('blur', () => {
      const val = parseFloat((input.value || '').replace(/[^0-9.-]/g, ''));
      input.value = isNaN(val) ? '' : fmt.format(val);
    });
    input.addEventListener('focus', () => {
      const val = parseFloat((input.value || '').replace(/[^0-9.-]/g, ''));
      input.value = isNaN(val) ? '' : val;
    });
  }
  attachCurrencyFormatter(spendInput);
  attachCurrencyFormatter(freightInput);

  function computeSavings(spend, freight) {
    const priceSavings       = spend * 0.05;
    const volumeSavings      = spend * (1 - (1 / 1.1)); // ~10%
    const freightSavings     = freight;
    const opportunitySavings = (spend * 0.1) * 0.3;
    const total = priceSavings + volumeSavings + freightSavings + opportunitySavings;
    return { priceSavings, volumeSavings, freightSavings, opportunitySavings, total };
  }

  function renderPlaceholders() {
    [priceCell, volumeCell, freightCell, opportunityCell, totalCell].forEach(el => {
      if (el) el.textContent = '--';
    });
  }

  function renderSavings({ priceSavings, volumeSavings, freightSavings, opportunitySavings, total }) {
    if (priceCell)       priceCell.textContent       = fmt.format(priceSavings);
    if (volumeCell)      volumeCell.textContent      = fmt.format(volumeSavings);
    if (freightCell)     freightCell.textContent     = fmt.format(freightSavings);
    if (opportunityCell) opportunityCell.textContent = fmt.format(opportunitySavings);
    if (totalCell)       totalCell.textContent       = fmt.format(total);
  }

  // --- Loading helpers ---
  function setLoading(isLoading) {
    if (!tableWrapper) return;
    tableWrapper.classList.toggle('is-loading', isLoading);
    if (overlay) overlay.setAttribute('aria-hidden', String(!isLoading));
    calcBtn.disabled = isLoading;
    calcBtn.textContent = isLoading ? 'Calculating…' : 'Calculate';
  }

  // Initial placeholders
  renderPlaceholders();

  // Click handler with 2s delay and loading state
  calcBtn.addEventListener('click', () => {
  const spend   = parseFloat((spendInput.value || '').replace(/[^0-9.-]/g, ''))   || 0;
  const freight = parseFloat((freightInput.value || '').replace(/[^0-9.-]/g, '')) || 0;

  // Show loading state
  setLoading(true);

  // Optional: reset cells while waiting
  renderPlaceholders();

  // Pick random delay between 2500 and 5000 ms
  const delay = Math.floor(Math.random() * (3500 - 1000 + 1)) + 1000;

  setTimeout(() => {
    const savings = computeSavings(spend, freight);
    renderSavings(savings);

    // Reformat inputs as currency after calculation
    if (spend)   spendInput.value   = fmt.format(spend);
    if (freight) freightInput.value = fmt.format(freight);

    // Hide loading state
    setLoading(false);
  }, delay);
});
});
